var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 26.25H25.75M12.25 35.25H19M1 6V42C1 43.1935 1.47411 44.3381 2.31802 45.182C3.16193 46.0259 4.30653 46.5 5.5 46.5H32.5C33.6935 46.5 34.8381 46.0259 35.682 45.182C36.5259 44.3381 37 43.1935 37 42V15.7695C36.9999 15.17 36.8801 14.5766 36.6475 14.0241C36.4149 13.4715 36.0742 12.971 35.6455 12.552L25.6555 2.7825C24.8148 1.96048 23.6858 1.50015 22.51 1.5H5.5C4.30653 1.5 3.16193 1.97411 2.31802 2.81802C1.47411 3.66193 1 4.80653 1 6Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 1.5V10.5C23.5 11.6935 23.9741 12.8381 24.818 13.682C25.6619 14.5259 26.8065 15 28 15H37",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileV2);
export default __webpack_public_path__ + "static/media/file_v2.414f36149e31a933b1910d80c4a81461.svg";
export { ForwardRef as ReactComponent };